var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickupMonitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20503 4.55078H5.41235V8.44199H9.20503V4.55078Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20503 10.3867H5.41235V14.2779H9.20503V10.3867Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5876 4.55078H16.7949V8.44199H20.5876V4.55078Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5876 10.3867H16.7949V14.2779H20.5876V10.3867Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8964 4.55078H11.1038V8.44199H14.8964V4.55078Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8964 10.3867H11.1038V14.2779H14.8964V10.3867Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4642 0H2.53583C1.13736 0 0 1.16691 0 2.60171V16.2232C0 17.658 1.13736 18.8249 2.53583 18.8249H9.52817V23.1838H5.08051V25H20.9195V23.1838H16.4718V18.8249H23.4642C24.8626 18.8249 26 17.658 26 16.2232V2.60171C26 1.16691 24.8626 0 23.4642 0ZM15.1442 23.1838H10.8603V18.8249H15.1442V23.1838ZM24.6723 16.2232C24.6723 16.9088 24.128 17.4628 23.4642 17.4628H2.53583C1.86757 17.4628 1.32766 16.9043 1.32766 16.2232V2.60171C1.32766 1.91609 1.872 1.36215 2.53583 1.36215H23.4642C24.1324 1.36215 24.6723 1.92063 24.6723 2.60171V16.2232Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupMonitor);
export default __webpack_public_path__ + "static/media/pickup-monitor.7fe1e523d2787562212e8edfe8011e7c.svg";
export { ForwardRef as ReactComponent };